module.exports = __webpack_public_path__ + "static/media/not-found.217828b9.svg";